var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"font-size":"24px"}},[_c('triz-validator',{attrs:{"rules":"required","id":"项目概述"}},[_c('Tinymce',{attrs:{"placeholder":"对于初始系统进行描述，并提出初始系统存在的问题"},on:{"input":_vm.change},model:{value:(_vm.triz.backgroud.init),callback:function ($$v) {_vm.$set(_vm.triz.backgroud, "init", $$v)},expression:"triz.backgroud.init"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }